<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Title</label>
          <v-text-field v-model="fields.title" label="Title" />
        </div>

        <div class="mt-6">
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields['background-color']"
                  name="background-color"
                  label="Background Color"
                  default-color="#ffffff"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields['text-color']"
                  name="text-color"
                  label="Text Color"
                  default-color="#000000"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields['background-icon']"
                  name="background-icon"
                  label="Icon Dot Color"
                  default-color="#cb6387"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox class="mt-0" v-model="fields.topPadding" label="Top padding" hide-details />
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox class="mt-0" v-model="fields.bottomPadding" label="Bottom padding" hide-details />
              </v-col>
              <v-col cols="12" md="12">
                <div class="mb-3">
                  <v-switch v-model="fields.enableContainerPage" label="Enable container page" hide-details />
                </div>
                <div v-show="fields.enableContainerPage">
                  <ColorPicker
                    v-model="fields.backgroundContainer"
                    name="background-container"
                    label="Background Container"
                    default-color="#ffffff"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mt-6">
          <label class="label-input">Title Card</label>
          <div class="group-item">
            <div class="mb-3">
              <v-checkbox v-model="fields['show-title']" label="Show title" hide-details class="mt-0 pt-0" />
            </div>
            <ckeditor :editor="editor" v-model="fields['title-card']" :config="editorConfig" />
          </div>
        </div>

        <div class="mt-6">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Items</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, index) in fields.listItem" :key="index">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Item {{ index + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveItem(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mb-4">
                  <UploadImage
                    @callback="obj => handleUploadImage(obj, index)"
                    :image="{ imageSrc: item.iconItem }"
                    :height="`180`"
                    :typeUpload="'image'"
                    @callbackDelete="() => handleRemoveUpload(index)"
                  />
                </div>
                <div>
                  <label>Description</label>
                  <ckeditor :editor="editor" v-model="item.textItem" :config="editorConfig" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import ColorPicker from './common/color-picker.vue';
import { replaceImageUrl } from '../common/utils';

export default {
  name: 'policy-yuri-list-section-editor',
  components: {
    UploadImage,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Policy Yuri List Section',
        'title-card': '<h2>Order Policy</h2><p></p>',
        'show-title': true,
        'background-icon': '#cb6387',
        'background-color': '#ffffff',
        'text-color': '#000000',
        enableContainerPage: true,
        topPadding: true,
        bottomPadding: true,
        listItem: [],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      listItem: Array.isArray(this.sectionEditor.sectionExtract?.listItem)
        ? this.sectionEditor.sectionExtract.listItem
        : this.fields.listItem,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.listItem.push({
        iconItem: replaceImageUrl('https://cdn.skyfastimg.com/images/2026/04/28/image-69f09a839afa141ca61a1f03.webp'),
        textItem: '<p>60-Day Money Back Guarantee</p>',
      });
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleUploadImage(obj, index) {
      this.fields.listItem[index].iconItem = obj.imageSrc;
    },
    handleRemoveUpload(index) {
      this.fields.listItem[index].iconItem = '';
    },
    handleSave() {
      const payload = {
        ...this.fields,
        listItem: (this.fields.listItem || []).map(item => ({
          iconItem: item.iconItem || '',
          textItem: item.textItem || '',
        })),
      };
      const updateHtml = updateHtmlFromData.sectionPolicyYuriList(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.ck-editor__editable_inline {
  min-height: 220px;
}
.ck-editor__editable {
  min-height: 220px;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
